// extracted by mini-css-extract-plugin
module.exports = {"primary":"#383a70"};